export default __webpack_public_path__ + "static/media/arrow-right.0a50eb25.svg";